import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ordersService {

  constructor(private api : ApiService,private http: HttpClient) { }

  getOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/job/getJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
  } 
  getFtlOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}tms-service/order/getOrderInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 

  getDraftJobs(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/job/getDraftJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

addOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/job/addOrUpdate')
  return this.api.post(url,formData);
}
draftAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/job/draftAddOrUpdate')
  return this.api.post(url,formData);
}
bulkAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/budget/bulkAddOrUpdate')
  return this.api.post(url,formData);
}
getRoleMappingList(){
  const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList`;
  return this.api.get(url);
} 

getBudgetTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/budget/getBudgetTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=DESC`;
  return this.api.post(url,formData);
}
getLineItemTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/job/getLineItemTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=ASC`;
  return this.api.post(url,formData);
}

updateLineItems(payload:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/job/addOrUpdate')
  return this.api.post(url,payload);
}
getAssociateList(payload:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&direction=ASC`;
  return this.api.post(url,payload);
}


getLocations(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/location/getLocations?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getVehicleType(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/vehicle/getVehicleType?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
} 
getMaterialType(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/vehicle/getMaterialType?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
getRoutes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/route/getRoutes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getAccounts(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ftl-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }

getNotificationLogs(payload:any) {
  const url = `https://ems-dev.apollosupplychain.com/comms-service/notification/getNotificationLogs?pageNumber=0&pageSize=10000`;
  // const payload = [{key: 'PINCODE_IN', value: pincode}];
  const headers = new HttpHeaders({
    'AuthUrl': `${environment.New_BASE_DOMAIN}/ftl-auth-service/validate/user`,
  });
  
  const req = new HttpRequest('POST', url, payload, {
    headers,
    reportProgress: true,
    responseType: 'json'
  });
  return this.http.request(req);
}

getOrderById(orderId:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/order/getById?orderId=${orderId}`;
  return this.api.get(url);
}
getOrderTripById(orderId:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/trip/getByOrderId?OrderId=${orderId}`;
  return this.api.get(url);
}

createUpdateOrder(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'tms-service/order/addOrUpdate')
  return this.api.post(url,formData);
}
createUpdateOrderBidding(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'bidding-service/order/addOrUpdate')
  return this.api.post(url,formData);
}
getVendorInfo(formData:any,pageNumber:any,pageSize:any){
  const url = (environment.New_BASE_DOMAIN + `account-service/vendor/getVendorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`)
  return this.api.post(url,formData);
}
getVendorOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}bidding-service/order/getOrders?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
tripGenration(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'tms-service/trip/addOrUpdate')
  return this.api.post(url,formData);
}
getGstList(accountId:any){
  const url = `${environment.New_BASE_DOMAIN}account-service/account/gst/getByAccountId?accountId=${accountId}`;
  return this.api.get(url);
}
saveEwayBill(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pod-service/ewaybill/addOrUpdate')
  return this.api.post(url,formData);
}
fetchEwayBill(ewayBillNumber:any,gstNumber:any){
  const url = `${environment.New_BASE_DOMAIN}integration-service/ewaybill/getEwayBillDetail?ewayBillNo=${ewayBillNumber}&gstNo=${gstNumber}`;
  return this.api.get(url);
}
saveTrip(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'tms-service/trip/addOrUpdate')
  return this.api.post(url,formData);
}
saveAllLr(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'tms-service/trip/lr/addOrUpdate')
  return this.api.post(url,formData);
}
getEwayBillList(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}pod-service/ewaybill/getEwayBills?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getLrInfoList(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}tms-service/trip/getLrInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getAdditionalCharges(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}pod-service/additionalCharges/getAdditionalCharges?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getPods(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}pod-service/pod/getPods?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
savePod(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pod-service/pod/addOrUpdate')
  return this.api.post(url,formData);
}
saveAdditionalCharge(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pod-service/additionalCharges/addOrUpdate')
  return this.api.post(url,formData);
}

}
